/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const radiusSix = (props) => `
    ${props.spcBag || (props.spcBag && props.theme.brand !== 'gym') ? `border-radius: 6px;` : ''}};
`;

const getWidth = (props) => {
  if (props.isPayPalDisabled && !props.isApplePayVisible) {
    return '243px';
  }

  if (props.isPayPalDisabled && props.isApplePayVisible) {
    return '140px';
  }
  return '140px';
};

const getPaddingStyle = (props) => {
  if (props.isDesktopProductTileCleanUpDisabled || props.sflItems?.size <= 0) {
    return '30px 24px 40px';
  }
  if (props.sflItems?.size > props.initialSFLItemsQty) {
    return '30px 24px 28px';
  }
  return '30px 24px 0px';
};

const styles = css`
  .ledgerForMobile {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
    }
  }
  .row-ele {
    width: 100%;
    margin: 15px 0;
    background: ${(props) => props.theme.colors.WHITE};
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .many-item-recommendation-non-empty-bag {
      .product-image-container {
        height: auto;
        min-height: 140px;
      }
    }
  }
  .order-summary {
    padding-bottom: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 16px 0;
      .checkoutBtnTracker {
        flex: none;
      }
    }
    .item-closed {
      .elem-mb-MED {
        margin-bottom: 0;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .overwrite-recommendation-css {
      .smooth-scroll-list-item {
        min-width: 130px !important;
      }

      .smooth-scroll-list-item:last-child {
        margin-right: 100px;
      }
    }
  }

  .cartPageTitleHeader {
    display: flex;
    justify-content: flex-start;
    @media ${(props) => props.theme.mediaQuery.medium} {
      justify-content: initial;
      pointer-events: none;
    }
  }

  .information-header {
    padding-left: 13px;
    padding-right: 13px;
    padding-top: 1px;
  }

  .with-condensed-header .information-header {
    flex: 1;
    background-color: ${(props) => props.theme.colors.WHITE};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  .bag-header {
    margin: 0;
    padding: 20px 0 20px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      text-align: center;
      padding: 13px 0 0;
      margin: 0;
      font-size: ${(props) => props.theme.fonts.fontSize.anchor.xlarge}px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-left: 3px;
    }
  }
  .bag-header-new {
    padding-left: 8px;
    margin: 6px 0px;
  }
  .sfl-when-empty-bag-or-guest-user {
    margin-bottom: 15px;
    padding: 18px 9px;
  }

  .delete-msg {
    position: sticky;
    z-index: 1111;
    width: 100%;
    box-sizing: border-box;
    top: 143px;
    border: solid 2px ${(props) => props.theme.colors.NOTIFICATION.SUCCESS};
    text-align: left;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    background: ${(props) => props.theme.colors.WHITE};
    display: flex;
    align-items: center;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    .tick-icon {
      height: 23px;
      width: 23px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }

  .estimatedHeaderText {
    display: none;
  }

  .bag-condensed-header {
    display: none;
  }
  .stickyErrorHeader {
    margin-left: 0;
    margin-right: 0;
    position: sticky;
    transition: all 0.5s ease-in-out;

    z-index: ${(props) => props.theme.zindex.zLoader};
    background: ${(props) => props.theme.colors.WHITE};
    top: ${(props) => (props.isHeaderStickyClassPresent ? `${props.stickyHeaderHeight}px` : '0px')};
  }

  .with-condensed-header {
    margin: 0px auto;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .bag-condensed-header {
      display: block;
      box-sizing: border-box;
      position: fixed;
      left: 0;
      right: 0;
      z-index: ${(props) => props.theme.zindex.zLoader};
      background: ${(props) => props.theme.colors.WHITE};
      width: 100%;
      margin: 0;
      border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[300]};
      transition: all 0.3s ease-in-out;
      transform: translateY(0);
    }
    .bagHeaderText {
      display: flex;
      align-items: center;
    }
  }

  .hidden-condensed-header {
    display: none;
  }

  .bag-section {
    & > .tile-header {
      border-bottom: none;
    }
  }
  .singleSflSection {
    margin: 0px;
    .transitions-style {
      border-bottom: none;
    }
  }
  .sflSection {
    margin: 0px;
    :last-child {
      .transitions-style {
        border: none;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .activeSection {
      display: block;
    }

    .singleSflSection {
      .transitions-style {
        border-bottom: none;
      }
    }
    .sflSection {
      :last-child .transitions-style {
        border: none;
      }
    }

    .inActiveSection {
      display: none;
    }
    .activeHeader {
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    }
    .estimatedHeaderText {
      display: block;
      text-align: center;
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
    .newEstimatedHeaderText {
      display: flex;
      text-align: center;
      justify-content: space-between;
      padding: ${(props) => (props.isUserLoggedIn ? '16px 9px 0px 9px' : '8px 9px 0px 9px')};
    }
    .newEstimatedHeader {
      font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
      font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    }
    .priceCurrency {
      font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
      font-size: ${(props) => props.theme.typography.fontSizes.fs18};
    }
    .activeEstimatedHeader {
      border-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS} solid
        ${(props) => props.theme.colors.TEXT.DARKERGRAY};
      &.save-for-later {
        margin-top: 10px;
      }
    }
    .stickyBagHeader {
      margin-left: 0;
      margin-right: 0;
      position: sticky;
      z-index: ${(props) => props.theme.zindex.zLoader};
      background: ${(props) => props.theme.colors.WHITE};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        top: ${(props) =>
          props.isHeaderStickyClassPresent ? `${props.stickyHeaderHeight}px` : '0px'};
      }
    }

    .share-cart-link {
      color: #1a1a1a;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-decoration-line: underline;
      border: none;
      background: transparent;
    }
    .cartPageTitleHeader {
      padding: 13px 4px;
      justify-content: space-between;
      .bag-header-new {
        padding: 0;
        margin: 0;
      }
    }
    .share-cart-container {
      display: flex;
      align-items: center;
      .cart-share-icon {
        width: 14px;
        height: 16px;
      }
    }
    .share-cart-error {
      padding: 0;
      margin: 0;
      .err-message-container {
        padding: 10px 12px;
      }
      .warning-icon {
        width: 22px;
        height: 22px;
      }
    }
  }

  .save-for-later-heading-block {
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    ${(props) =>
      (props.isDesktopProductTileCleanUpDisabled || props.sflItems?.size <= 0) &&
      `border-bottom: 1px solid #e3e3e3;`}
  }
  .save-for-later-section {
    border-radius: 10px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      background-color: #fff;
      padding: ${(props) => getPaddingStyle(props)};
      margin-bottom: 50px;
    }
  }

  .save-for-later-section-heading {
    display: block;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
      position: relative;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      text-transform: ${(props) =>
        props.isDesktopProductTileCleanUpDisabled ? 'uppercase' : 'capitalize'};
    }
  }
  .save-for-later-section-heading:after {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      content: '';
      position: absolute;
      background-color: ${(props) => props.theme.colors.BRAND.PRIMARY};
      height: 3px;
      width: 100%;
      left: 0;
      bottom: -10px;
      border-radius: 5px;
    }
  }

  .bag-header-sfl {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
      font-size: ${(props) => props.theme.typography.fontSizes.fs18};
      text-transform: uppercase;
    }
  }

  .recentlyViewed {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .may-like-recommendation {
    margin-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.XXS};
    ${(props) =>
      props.isRecommendationCarouselRedesignEnabled &&
      `
    background: white;
    border-radius: 10px;
    @media ${props.theme.mediaQuery.medium} {
      padding-right: 6px;
    }
    .recommendations-header-new{
      margin-top: 20px;
    }

   `}
  }
  ${(props) =>
    props.isRecommendationCarouselRedesignEnabled &&
    `
  .recentlyViewed {
    background: white;
    border-radius: 10px;
    overflow: hidden;
    .recommendations-wrapper .recommendation-product-section {
      padding: 0 6px 0px 0px;
    }
  }
  .recommendations-wrapper .recommendation-product-section {
    min-height: 352px;
    padding: 0 0px 18px 0px;
    @media ${props.theme.mediaQuery.smallOnly} {
      min-height: 315px;
      padding: 0px;
    }
  }
  .recommendation-product-section .slick-arrow.slick-next{
    right: 20px;
  }
 `}
  .cart-placecash {
    border-radius: 14px;
    border: solid 4px ${(props) => props.theme.colors.REWARDS.PLACE_CASH};
    margin: 10px 0 0 0;
    width: 100%;
    height: auto;
    background: ${(props) => props.theme.colors.WHITE};
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: inline-flex;
      justify-content: center;
      align-items: stretch;
    }
  }

  .cart-placecash.hide-content {
    display: none;
  }

  .cart-placecash .cart-placecash-button {
    background-color: ${(props) => props.theme.colors.REWARDS.PLACE_CASH_BACKGROUND};
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 37%;
    }
  }

  .cart-placecash .place-cash {
    padding: 16px 10px 5px;
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 0px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      box-sizing: border-box;
    }
  }

  .cart-placecash .place-cash__text-wrapper {
    position: static;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
  }

  .cart-placecash .progress-bar__outer-container {
    margin: 0 8px;
    border: 1px solid ${(props) => props.theme.colors.REWARDS.PLACE_CASH};
    border-radius: 16.5px;
    background: ${(props) => props.theme.colors.WHITE};
  }

  .cart-placecash .progress-bar__outer-container__all {
    justify-content: center;
    align-items: center;
    margin: 16px auto;
  }

  .cart-placecash .progress-bar__outer-container__startvalue,
  .cart-placecash .progress-bar__outer-container__endvalue {
    margin: 0;
    display: inline-table;
    width: auto;
  }

  .cart-placecash .progress-bar__outer-container__startvalue span,
  .cart-placecash .progress-bar__outer-container__endvalue span {
    font-size: 12px;
  }

  .cart-placecash .progress-bar__title-text,
  .cart-placecash .progress-bar__amount-text {
    font-size: 14px;
  }
  .cart-placecash .progress-bar__text-wrapper {
    width: 90%;
  }
  .cart-placecash .progress-bar__title-text .progress-bar_redeem-dates {
    font-weight: ${(props) => props.theme.fonts.fontWeight.light};
  }

  .cart-placecash .progress-bar__status-bar {
    height: 20px;
  }

  .cart-placecash .place-cash__tnc-container {
    font-size: 10px;
  }

  .cart-placecash .place-cash__tnc-text {
    font-size: 10px;
  }

  .cart-placecash .place-cash__modalLink {
    font-size: 10px;
    text-transform: capitalize;
  }

  .cart-placecash .horizontal-line {
    border-top: solid 1px ${(props) => props.theme.colors.TEXT.LIGHTGRAY};
    width: 90%;
    text-align: center;
    display: none;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: block;
    }
  }

  .cart-placecash.placereward {
    border-left: solid 4px ${(props) => props.theme.colors.REWARDS.PLCC};
    border-top: solid 4px ${(props) => props.theme.colors.REWARDS.PLCC};
    border-right: solid 4px ${(props) => props.theme.colors.REWARDS.NON_PLCC};
    border-bottom: solid 4px ${(props) => props.theme.colors.REWARDS.NON_PLCC};
  }

  .cart-placecash.plcc-user .cart-placecash-button {
    background: ${(props) => props.theme.colors.WHITE};
  }
  .cart-placecash.plcc-user .progress-bar__status-bar {
    background-image: repeating-linear-gradient(-76deg, #62c9ec 0 29px, #00a7e0 29px 56px);
  }

  .cart-placecash.plcc-user .progress-bar__outer-container {
    border: 1px solid ${(props) => props.theme.colors.REWARDS.PLCC};
  }

  .cart-placecash.no-plcc-user .cart-placecash-button {
    background: ${(props) => props.theme.colors.WHITE};
  }
  .cart-placecash.no-plcc-user .progress-bar__status-bar {
    background-image: repeating-linear-gradient(-76deg, #f9b662 0 29px, #f7971f 29px 56px);
  }

  .cart-placecash.no-plcc-user .progress-bar__outer-container {
    border: 1px solid ${(props) => props.theme.colors.REWARDS.NON_PLCC};
  }

  .cart-placecash .my-place-image {
    height: 14px;
    position: relative;
    top: 3px;
    margin-right: 5px;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 14px;
      padding: 5px 0;
      top: 0;
      display: block;
      margin: 0 auto;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .cart-placecash .cart-placecash-product {
      width: 63%;
      position: relative;
      display: inline-block;
    }
  }
  .show-less-block {
    display: flex;
    justify-content: center;
    margin-top: ${(props) => (props.isDesktopProductTileCleanUpDisabled ? '16px' : '0px')};
  }
  ${(props) =>
    props.isMobileWebTileEnhancementEnabled &&
    `.bag-items-section .bag-items {
    margin-left: 0px;
    margin-right: 0px;
    width: 100%;
      .tabs {
        border-radius: 0px;
      }
      .rounded-container {
        border-radius: 0px;
      }
  }`}
`;

export const recommendationStylesPdp = css`
  .accordion-recommendation {
    font-family: Nunito;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 0.2px;
    text-align: center;
    color: ${(props) => props.theme.colors.TEXT.DARK};
    margin: 14px auto 14px;
    pointer-events: none;
    border-top: 0;
    padding: 0;
    background: none;
    line-height: 1;
    text-transform: none;
    width: 85%;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 22px auto 4px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin: 14px auto 6px;
    }
  }

  .recommendations-container {
    padding: 0;
    overflow: hidden;
  }

  .recommendations-header {
    text-align: left;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.anchor.medium}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.semibold};
    margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED} 10px;
    letter-spacing: normal;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED}
        ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.fonts.fontSize.anchor.large}px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.black};
      margin: 0 0 18px 18px;
    }
  }
  && .smooth-scroll-list {
    padding-bottom: 10px;
    .smooth-scroll-list-item {
      margin: 2px 12px 2px 0px;
      position: relative;
      width: 38%;
      padding: 0px;
      border-radius: 11px;
      box-shadow: 0 2px 6px 0px rgb(0 0 0 / 10%);
      left: 10px;
      min-height: 257px;
      height: 257px;
      .product-list {
        margin: 0px;
      }
    }
  }

  .slick-slide {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin: 2px 10px 5px 0px;
      position: relative;
      padding: 0px;
      border-radius: 11px;
      box-shadow: 0 2px 6px 0px rgb(0 0 0 / 10%);
      height: auto;
    }
  }

  .slick-track {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      padding: 6px;
    }
  }

  .favorite-move-purchase-section {
    display: none !important;
  }

  && .item-container-inner {
    padding: 8px 7px 0 7px;
  }
  && .product-image-container {
    height: 131px;
    min-height: 131px;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
      height: 131px !important;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 144px;
      min-height: 144px;
      margin: 4px;
      float: left;
      width: 48%;
      position: relative;
    }
  }
  && .container-price {
    p {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      margin-top: 0px;
      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 20px;
        margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
    }
    span {
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 14px;
        display: block;
      }
    }
  }
  && .custom-ranking-container {
    img {
      width: 60px;
      height: 12px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        width: 63px;
        height: 13px;
      }
    }
    .reviews-count {
      font-size: 10px;
      color: ${(props) => props.theme.colors.TEXT.DARK};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: 3px;
      }
      @media ${(props) => props.theme.mediaQuery.medium} {
        margin-top: 0px;
      }
    }
  }
  && .added-to-bag {
    font-size: 10px;
    padding: 8px 0;
    min-height: 42px;
    letter-spacing: normal;
    margin-top: 0px;
    ${(props) => radiusSix(props)}
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 33px;
      margin-top: 6px;
    }
  }

  .recommendations-section-row {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 10px 2px;
    }
    .no-carousel-container {
      ul {
        width: 143px;
      }
    }
  }

  .ranking-wrapper {
    min-height: 23px;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 22px;
    }
  }

  .fulfillment-section,
  .ranking-wrapper {
    margin-top: 0px !important;
  }

  .product-wishlist-container + .fulfillment-section {
    margin-top: 23px !important;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 22px !important;
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .no-carousel-container {
      ul {
        width: 115px;
      }
    }
    && .slick-prev {
      left: -8.5%;
    }
    && .slick-next {
      right: -8.5%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .tcp_carousel_wrapper {
      height: 210px;
    }
    && .recommendation-height-toggle {
      display: none;
    }
    && .slick-slide {
      height: 156px;
      margin: 3px 11px;
      padding: 0px;
      border-radius: 11px;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    }
    && .item-container-inner {
      padding: 0px;
      display: block;
    }
    && .no-carousel-container {
      ul {
        width: 135px;
      }
    }
    && .product-wishlist-container > div:first-child {
      display: none;
      height: 0px;
    }
    && .product-wishlist-container {
      width: 47%;
      float: left;
      margin-top: auto;
      position: relative;
      min-height: 80px;
      height: 80px;
      padding-top: 0px;
    }
    && .fulfillment-section {
      width: 43%;
      float: left;
    }
    && .ranking-wrapper {
      width: 47%;
      transform: scale(0.83);
      position: relative;
      left: -10px;
      float: left;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    }

    && .slick-prev {
      left: -3.5%;
    }
    && .slick-next {
      right: -4.5%;
    }
  }
  && .slick-list {
    margin-right: 0;
    overflow: none;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-height: 280px;
    }
  }
  && .slick-dots {
    bottom: -25px;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      bottom: 0px;
    }
  }
`;

export const addedToBagActionsStyles = css`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    bottom: 0;
    left: 0;
    position: ${(props) =>
      props.isPLCCInstantCheckout && !props.isInternationalShipping ? 'initial' : 'fixed'};
    width: 92%;
    background: ${(props) => props.theme.colors.WHITE};
    z-index: 999;
    margin: 0;
    border-top: ${(props) =>
        props.isPLCCInstantCheckout && !props.isInternationalShipping
          ? 0
          : props.theme.spacing.ELEM_SPACING.XXXS}
      solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    ${(props) =>
      props.isStickyCheckoutButtonEnabled &&
      `
    position:relative;
    width:auto;
    border-top:none;

    `}
  }

  margin-bottom: 0px;

  .checkout-sticky-header .paypal-wrapper {
    ${(props) =>
      props.isExpressAfterpayEnabled
        ? `
            background-image: url('${getIconPath('paypal-logo', props)}');
            background-repeat: no-repeat;
            background-size: 55%;
            background-position: 50%;
            overflow: hidden;
            border-radius: ${
              props.theme.brandSpecificStyles.VENMO_BUTTON_OVERLAY
                .VENMO_OVERLAY_BUTTON_BORDER_RADIUS
            };
            border: 1px solid ${props.theme.colorPalette.venmoBorder};
            box-sizing: border-box;
            height: 42px;
            .paypal-wrapper-content{
              opacity: 0.01;
            }`
        : ''}
  }

  ${(props) =>
    props.isExpressAfterpayEnabled &&
    props.isApplePayVisible &&
    `
  .apple-wrapper {
    margin-top: ${props.theme.spacing.ELEM_SPACING.XS};
    height: 48px;
  }`}

  ${(props) =>
    props.isPayPalDisabled &&
    props.isApplePayVisible &&
    `.checkout-sticky-header .apple-wrapper {
   width: 140px;
  }`}

  .checkout-button.checkout-button-bagHeader {
    flex-direction: row-reverse;
    margin-top: 7px;
    float: right;
    padding: 0 3px 0 13px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      .checkoutBtnTracker {
        max-width: ${(props) => getWidth(props)};
        margin-right: 10px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      .checkoutBtnTracker {
        margin-right: 2px;
      }
    }
    .checkout {
      height: 42px;
      padding: 12px 0;
    }
    .paypal-venmo {
      flex: 2;
      display: inline-flex;
      margin-bottom: 7px;
      ${(props) =>
        !props.isVenmoEnabled && !props.isPayPalEnabled && !props.isExpressAfterpayEnabled
          ? `flex: none;`
          : ''};
      ${(props) => (props.isExpressAfterpayEnabled ? `flex-direction: row;` : '')}
      .paypal-wrapper {
        min-width: auto;
      }
      .venmo-button {
        height: 42px;
      }
    }
    .checkoutBtn-wrapper {
      min-width: ${(props) => getWidth(props)};
      @media ${(props) => props.theme.mediaQuery.medium} {
        ${(props) => (!props.isMiniBag ? 'max-width: 140px; margin-right: 2px;' : '')};
      }
    }
    .after-pay-block {
      margin: 0 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      width: 100%;
      height: 42px;
      background-size: 100%;
      border-radius: 4px;
      min-width: 120px;
      border: 1px solid black;
      max-width: 150px;
      box-sizing: border-box;
    }

    ${(props) =>
      props.isExpressAfterpayEnabled &&
      `
    .apple-wrapper {
      margin: 0 0 0 ${props.theme.spacing.ELEM_SPACING.XXS};
      height: 42px;
    }`}
  }

  .paypal-adyen-container {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      min-width: 50%;
    }
  }

  .paypal-applePay-container-adyen {
    display: flex;
    @media ${(props) => props.theme.mediaQuery.medium} {
      .paypal-adyen-container {
        width: 50%;
      }
    }
  }
  .paypal-venmo-container-adyen {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex;
    }
  }
  .paypal-venmo-container-adyen.checkout-sticky-header {
    width: 290px;
  }
  .checkout-sticky-header {
    margin-right: ${(props) =>
      props.isApplePayVisible ? '' : props.theme.spacing.ELEM_SPACING.XS};
  }

  .checkout-button {
    display: flex;
    flex: 1;
    flex-direction: column-reverse;
    width: 100%;
    margin: 0;
    padding: 0 13px 0;
    box-sizing: border-box;
    margin-top: ${(props) =>
      props.isPLCCInstantCheckout && !props.isInternationalShipping ? '22px' : '23px'};
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-top: 0;
      padding: 0;
      ${(props) =>
        ((!props.isVenmoEnabled && !(props.isApplePayVisible && !props.isMiniBag)) ||
          (!props.isPayPalEnabled && !props.isPayPalEnabledKillSwitch)) &&
        !props.isPLCCInstantCheckout
          ? `flex-direction: row;
          .checkoutBtnTracker {
            flex: 1;
            padding-left: ${props.isPayPalDisabled ? '0px' : '8px'};
          }`
          : ''};
      ${(props) =>
        (!props.isVenmoEnabled && !props.isPayPalEnabled) ||
        (props.isApplePayVisible && !props.isMiniBag && props.isPayPalEnabled)
          ? `.checkoutBtnTracker {
              flex: 1;
              padding-left: 0;
            }`
          : ''};
      .checkout {
        height: 42px;
        padding: 12px 0;
      }
      .paypal-wrapper {
        ${(props) => (props.isExpressAfterpayEnabled ? '' : 'min-width: 170px;')}
        height: 42px;
        ${(props) =>
          props.isExpressAfterpayEnabled &&
          !props.isStickyCheckoutButtonEnabled &&
          !props.isPLCCInstantCheckout
            ? `
            background-image: url('${getIconPath('paypal-logo', props)}');
            background-repeat: no-repeat;
            background-size: 70%;
            background-position: 50%;
            overflow: hidden;
            border-radius: ${
              props.theme.brandSpecificStyles.VENMO_BUTTON_OVERLAY
                .VENMO_OVERLAY_BUTTON_BORDER_RADIUS
            };
            border: 1px solid ${props.theme.colorPalette.venmoBorder};
            box-sizing: border-box;
            .paypal-wrapper-content{
              opacity: 0.01;
            }`
            : ''}

        ${(props) =>
          props.isPLCCInstantCheckout &&
          `
          width: 100%;
         `}
      }
      .after-pay-block {
        ${(props) =>
          !props.isPLCCInstantCheckout &&
          !props.isStickyCheckoutButtonEnabled &&
          `margin: 0 0 0 ${props.theme.spacing.ELEM_SPACING.XS};`}
        width: 100%;
        height: 42px;
        ${(props) =>
          props.isPLCCInstantCheckout || props.isStickyCheckoutButtonEnabled
            ? `
          background-size: 55%;`
            : `background-size: 105%;`}
        border-radius: 4px;
        border: 1px solid black;
        box-sizing: border-box;
      }
      ${(props) =>
        props.isExpressAfterpayEnabled &&
        props.isApplePayVisible &&
        !props.isPLCCInstantCheckout &&
        !props.isStickyCheckoutButtonEnabled &&
        `
      .apple-wrapper {
        margin-left: 8px;
        margin-top: 0;
        height: 42px;
      }`}
      .venmo-button {
        min-width: 170px;
        height: 42px;
      }
    }
  }

  button.checkout {
    width: 100%;
    margin: 0 0 10px 0;
    padding: 16px 0;
    ${(props) => radiusSix(props)}
    ${(props) => !props.isMiniBag && props.theme.brandSpecificStyles.BAG_PAGE_STYLES.BORDER_RADIUS}
  }
`;

export const recommendationStyles = css`
  /* stylelint-disable no-descending-specificity */
  .recommendations-container {
    padding: 16px 0 24px 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 24px 0 32px 0;
    }
  }
  .smooth-scroll-list-item {
    width: 33%;
    margin-right: 0;
  }
  .custom-ranking-container {
    img {
      width: 68px;
      ${(props) => !props.isRecommendationCarouselRedesignEnabled && `height: 13px;`}
    }
    .reviews-count {
      font-size: 10px;
      color: ${(props) => props.theme.colors.TEXT.DARK};
      margin-top: ${(props) =>
        props?.isRatingRedesignAbTest ? props.theme.spacing.ELEM_SPACING.XS_7 : `1px`};
    }
    line-height: 15px;
  }
  /* stylelint-enable no-descending-specificity */

  .recommendations-header {
    text-align: left;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.anchor.xlarge}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED} 10px;
    letter-spacing: normal;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED}
        ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.fonts.fontSize.anchor.xlarge}px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      margin: 0 0 18px 18px;
    }
  }
  && .item-container-inner {
    padding: 0 6.5px;
  }
  && .container-price {
    p {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      font-size: ${(props) => props.theme.fonts.fontSize.listmenu.small}px;
    }
    .list-price {
      font-size: 9px;
      color: #6d7278;
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    }
    .merchant-tag {
      font-size: 9px;
      color: #c01f1f;
    }
  }
  && .added-to-bag {
    font-size: ${(props) => props.theme.fonts.fontSize.body.small.primary}px;
    padding: 8px 0;
    min-height: auto;
    letter-spacing: normal;
    ${(props) => radiusSix(props)}
  }
  .recommendations-section-row {
    .no-carousel-container {
      ul {
        width: 143px;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .recommendations-section-row {
      .recommendations-section-col {
        ${(props) =>
          !props.fromBIA
            ? ` margin-left: 10%;
        margin-right: 10%;
        width: 80%;`
            : 'width: 100%;'}
      }
    }
    .no-carousel-container {
      ul {
        width: 119px;
      }
    }
    && .slick-prev {
      left: -8.5%;
    }
    && .slick-next {
      right: -8.5%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    && .item-container-inner {
      padding: 0 12.5px;
    }
    && .no-carousel-container {
      ul {
        width: 261px;
      }
    }
    && .slick-prev {
      left: -5.5%;
    }
    && .slick-next {
      right: -5.5%;
    }
  }
  && .slick-list {
    margin-right: 0;
  }

  .product-wishlist-container + .fulfillment-section {
    margin-top: 23px;
  }
`;

export default styles;
